import { useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../Assets/Juliana-Logo-Transparent.svg";
import { CloseMenu } from "../../Icons/CloseMenu";
import { OpenMenu } from "../../Icons/OpenMenu";
import { nav } from "../../data";
import NavbarProps from "../Props/NavbarProps";

function NavbarMobile() {
  const [isActive, setIsActive] = useState(false);

  const toggle = () => setIsActive((prev) => !prev);

  const closeMenu = () => setIsActive(false);

  return (
    <section className="mobile-nav-container">
      <div className="button-mobile-nav">
        <NavLink to={"/"}>
          <div className="logo-container">
            <img src={Logo} alt="Juliana Antunes Advocacia" className="logo" />
          </div>
        </NavLink>

        <div onClick={toggle}>{isActive ? <CloseMenu /> : <OpenMenu />}</div>
      </div>

      <div className={`mobile-nav container ${isActive ? "active" : ""}`}>
        <NavbarProps data={nav} onClick={closeMenu} />
      </div>
    </section>
  );
}

export default NavbarMobile;
